import React, { memo, useEffect, useState } from 'react'
import { FilterDropoffDate } from 'apps/fleet-planner/pages/loads/FilterDropoffDate'
import {
  FilterFacilityDropoffLocation,
  FilterFacilityLocationPickup,
} from 'apps/fleet-planner/pages/loads/FilterFacilityLocation'
import { FilterPickupDate } from 'apps/fleet-planner/pages/loads/FilterPickupDate'
import { FilterReferenceNumber } from 'apps/fleet-planner/pages/loads/FilterReferenceNumber'
import { ILoadFilters } from 'apps/fleet-planner/types'
import { Button, FormModal } from 'transfix-ui'

interface ILoadsFiltersModalProps {
  currentFilters: Partial<ILoadFilters>
  isFilterModalOpen: boolean
  onClearFilter: () => void
  onCloseModal: () => void
  onChangeFilter: (change: Partial<ILoadFilters>) => void
}

export const LoadsFiltersModal = memo<ILoadsFiltersModalProps>(
  ({
    currentFilters = {},
    isFilterModalOpen,
    onClearFilter: onClearFilterProp,
    onCloseModal: onCloseModalProp,
    onChangeFilter: onChangeFilterProp,
  }) => {
    const [newFilters, setNewFilters] = useState<ILoadsFiltersModalProps['currentFilters']>(
      currentFilters
    )

    const setNewFilter = (change: Partial<ILoadFilters>) => {
      setNewFilters(prev => ({
        ...prev,
        ...change,
      }))
    }

    // Update local state
    useEffect(() => {
      setNewFilters(currentFilters)
    }, [currentFilters])

    return (
      <FormModal
        open={isFilterModalOpen}
        title='Filters'
        actions={[
          {
            label: 'Cancel',
            type: 'dismiss',
            dataTest: 'filters-cancel',
            action: onCloseModalProp,
          },
          {
            label: 'Apply Filters',
            type: 'confirm',
            dataTest: 'filters-save',
            action: () => {
              onChangeFilterProp(newFilters)
              onCloseModalProp()
            },
          },
        ]}
        onClose={onCloseModalProp}>
        <div className='col-xs-12 col-md-4 col-lg-3 mb3 mb0-m'>
          <FilterFacilityLocationPickup
            value={currentFilters}
            onChange={setNewFilter}
            label='Pickup Location'
            placeholder='Enter a city, state, or facility'
            dataTest='loads-filter-pu-loc'
          />
        </div>
        <div className='col-xs-12 col-md-4 col-lg-3 mb3 mb0-m'>
          <FilterFacilityDropoffLocation
            value={currentFilters}
            onChange={setNewFilter}
            label='Dropoff Location'
            placeholder='Enter a city, state, or facility'
            dataTest='loads-filter-do-loc'
          />
        </div>
        <div className='col-xs-12 ph0 col-md-8 col-lg-3 mb3 mb0-m'>
          <div className='col-xs-6'>
            <FilterPickupDate value={currentFilters} onChange={setNewFilter} />
          </div>
          <div className='col-xs-6'>
            <FilterDropoffDate value={currentFilters} onChange={setNewFilter} />
          </div>
        </div>
        <div className='col-xs-12 col-md-4 col-lg-2'>
          <FilterReferenceNumber value={currentFilters} onChange={setNewFilter} />
        </div>
        <div className='col-xs-12 col-md-4 col-lg-1'>
          <Button
            color='tertiary'
            size='large'
            onClick={onClearFilterProp}
            className='loads-filters-clear-all-btn'
            data-test='loads-filters-clear-all-btn'>
            Clear All
          </Button>
        </div>
      </FormModal>
    )
  }
)
